<template>
	<button class="button" :class="'button--' + type" @click="click($event)">
		{{wording}}
	</button>
</template>
<script>
	export default {
		name: 'AppButton',
		props: {
			wording: {
				type: String,
				required: true,
			},
			type: {
				type: String,
				default: 'secondary',
			}
		},
		methods: {
			click: function(evt) {
				this.$emit('click', evt)
			}
		}
	}
</script>
<style lang="scss">
	@import 'global/css/contexte.apps.fonts';
	@import 'global/css/contexte.apps.colors';
	.button {
		cursor: pointer;
		border: none;
		display: block;
		text-align: center;
		font-size: 16px;
		font: 400 14px/140% $sans;
		&:focus {
			outline: none;
			box-shadow: 0 0 0 5px white;
			box-shadow: 0 0 0 10px $red;
		}
		&:hover {
			transform: translateY(-2px);
		}
		&:selected {
			box-shadow: none;
		}
		&--primary {
			padding: .7em 3em;
			background-color: $another-grey;
			color: white;
			text-transform: uppercase;
		}
		&--secondary {
			font-size: 13px;
			padding: .6em 2em;
			background-color: $very-light-grey;
			// border: 1px solid $light-grey;
		}
		&--badass {
			background-color: $red;
			font-size: clamp(14px, 2.2vw, 25px);
			color: white;
			text-transform: uppercase; 
			padding: .6em 2em;
			&:focus {
				outline: none;
				box-shadow: 0 0 0 5px white;
				box-shadow: 0 0 0 10px $light-grey;
			}
		}
	} 
</style>